import type { SongSummary } from '@pipi/shared';
import { LoaderCircle } from 'lucide-react';
import { SongCard } from './song-card';

export function SongGrid({ songs, loading = false }: { songs: SongSummary[]; loading?: boolean }) {
  if (loading && !songs.length) {
    return (
      <div className="catalog-loading">
        <LoaderCircle className="spin" size={34} />
        <span>正在整理曲库</span>
      </div>
    );
  }
  return <div className="song-grid">{songs.map((song, index) => <SongCard key={song.id} song={song} index={index} />)}</div>;
}
